import './Demo.css';

function Demo() {
  return (
    <section className="Demo">
      <h2>2026 Demo</h2>
      <iframe src="https://www.youtube.com/embed/AMq3-LDQjNI?si=qSxiHvbD49bWTbpL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    </section>
  );
}

export default Demo;
